var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("navigation-layout", { ref: "navigationlayout" }, [
    _c("h1", { attrs: { slot: "title" }, slot: "title" }, [
      _vm._v(_vm._s(_vm.title))
    ]),
    _vm._v(" "),
    _c("h3", { attrs: { slot: "abstract" }, slot: "abstract" }, [
      _vm._v(_vm._s(_vm.abstract))
    ]),
    _vm._v(" "),
    _c("main", [
      _c(
        "div",
        [
          _c(
            "md-list",
            _vm._l(_vm.facilities, function(facility, index) {
              return _c(
                "md-list-item",
                {
                  key: index,
                  on: {
                    click: function($event) {
                      return _vm.selectfacility(facility)
                    }
                  }
                },
                [
                  _vm.isSelected(facility.id)
                    ? _c("md-icon", { staticClass: "md-primary" }, [
                        _vm._v("star")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  facility.logoUrl
                    ? _c("img", {
                        staticClass: "facility-logo",
                        attrs: {
                          src: facility.logoUrl,
                          alt: facility.companyName
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "md-list-item-text" }, [
                    _c("span", [_vm._v(_vm._s(facility.companyName))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(facility.name))])
                  ])
                ],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f86b55e0", { render: render, staticRenderFns: staticRenderFns })
  }
}